// extracted by mini-css-extract-plugin
export default {"root":"ChangePassSeccess_root__F+4OO","btn":"ChangePassSeccess_btn__c6xVv"};